<template>
  <div class="tabs">
    <button
      v-for="tab in tabs"
      :key="tab.type"
      :class="{ active: modelValue === tab.type }"
      @click="$emit('update:modelValue', tab.type)"
    >
      {{ tab.label }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      required: true
    },
    tabs: {
      type: Array,
      required: true
    }
  },
  emits: ['update:modelValue']
}
</script>

<style scoped>
.tabs {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 0;
  flex-wrap: wrap;
}

.tabs button {
  color: #5F5E5B;
  background: none;
  border: none;
  padding: 0.5rem;
  margin: 0 0.5rem 0.5rem 0;
  font-size: 1em;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: color 0.2s;
  transition: border 0.3s;
}

.tabs button.active {
  border-bottom: 2px solid var(--primary-color);
  color: var(--primary-color);
}

.tabs button:hover {
  border-bottom: 2px solid var(--secondary-color);
  color: var(--secondary-color);
}

@media (max-width: 700px) {
  .tabs {
    width: 100%;
    justify-content: flex-start;
    margin-top: 0.5rem;
  }
  
  .tabs button {
    margin-top: 0.5rem;
  }
}
</style>